import {PlusIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {forwardRef} from 'react'
import styles from './AddIssueFieldButton.module.css'

export const AddIssueFieldButton = forwardRef<
  HTMLButtonElement,
  {
    anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
  }
>((props, ref) => {
  const {anchorProps} = props
  return (
    <div className={styles.container}>
      <Button trailingVisual={PlusIcon} size="small" ref={ref} {...anchorProps} className={styles.button}>
        Add field
      </Button>
    </div>
  )
})
AddIssueFieldButton.displayName = 'AddIssueFieldButton'
